(function() {
  'use strict';

  angular.module('app').factory('SelectService', SelectService);

  SelectService.$inject = [
    '$rootScope',
    '$filter',
    'BusinessService',
    'SettingsService',
    'LoyaltyService',
    'POSService',
    'TerminalService',
    'GoodsService',
    'NewsService'];

  function SelectService(
      $rootScope, $filter, BusinessService, SettingsService, LoyaltyService, POSService, TerminalService, GoodsService, NewsService) {

    var service = {};

    var _req_gc = ['LPR_LIST', 'LP_LIST', 'L_LIST', 'GOODS_CATEGORIES_FLAT'];

    initVars();

    function initVars() {
      for (var i in _req_gc)
        $rootScope[_req_gc[i]] = [];
    }

    $rootScope.$on('user-login', function() {
      initVars();
    });

    $rootScope.$on('user-register', function() {
      initVars();
    });

    $rootScope.$on('user-logout', function() {
      for (var i in _req_gc)
        $rootScope[_req_gc[i]] = null;
    });

    service.getLoyaltiesList = function(callback) {
      LoyaltyService.All(function(success, response) {
        if (callback) {
          callback(success, response);
        }
      });
    };

    service.getPOSList = function(callback) {
      POSService.All({}, function(success, response) {
        callback(success, response);
      });
    };

    service.getRegistersList = function(callback) {
      TerminalService.All(function(success, response) {
        callback(success, response);
      });
    };

    /**
     * Make list for select control with layers Loyalty -> POS -> TERMINALS
     */
    service.getLPRList = function(callback) {
      LoyaltyService.All(function(success, LOYALTIES) {
        if (success) {
          POSService.All({}, function(success, POS) {
            if (success) {
              TerminalService.All(function(success, TERMINALS) {
                if (success) {
                  var l = angular.copy(LOYALTIES),
                      p = angular.copy(POS),
                      r = angular.copy(TERMINALS),
                      list = [];

                  for (var i in l) {
                    l[i].filter_list_type = 'loyalty';
                    list.push(l[i]);

                    for (var k in p) {
                      if (p[k].loyalty_id === l[i].id) {
                        // if (l[i].active === 0)
                        //     p[k].active = 0;
                        p[k].filter_list_type = 'pos';

                        list.push(p[k]);

                        for (var m in r) {
                          if (r[m].pos_id === p[k].id) {
                            // if (p[k].active === 0)
                            //     r[m].active = 0;

                            r[m].filter_list_type = 'register';
                            list.push(r[m]);
                          }
                        }
                      }
                    }
                  }

                  $rootScope.LPR_LIST = list;
                  if (callback) {
                    callback(list);
                  }
                }
              });
            }
          });
        }
      });
    };

    /**
     * Make list for select control with layers Loyalty -> POS
     */
    service.getLPList = function(callback) {
      LoyaltyService.All(function(success, LOYALTIES) {
        if (success) {
          POSService.All({}, function(success, POS) {
            if (success) {
              var l = angular.copy(LOYALTIES),
                  p = angular.copy(POS),
                  list = [];

              for (var i in l) {
                l[i].filter_list_type = 'loyalty';
                list.push(l[i]);

                for (var k in p) {
                  if (p[k].loyalty_id === l[i].id) {
                    // if (l[i].active === 0)
                    //     p[k].active = 0;
                    p[k].filter_list_type = 'pos';

                    list.push(p[k]);
                  }
                }
              }

              $rootScope.LP_LIST = list;
              if (callback) callback(list);
            }
          });
        }
      });
    };

    /**
     * Make list for select control with layers Loyalty
     */
    service.getLList = function(callback) {
      LoyaltyService.All(function(success, LOYALTIES) {
        if (success) {
          var l = angular.copy(LOYALTIES),
              list = [];

          for (var i in l) {
            l[i].filter_list_type = 'loyalty';
            list.push(l[i]);
          }

          $rootScope.L_LIST = list;
          if (callback) callback(list);
        }
      });
    };

    service.getCountriesList = function() {
      SettingsService.Countries(function(success, data) {
      });
    };

    service.getTimezonesList = function(callback) {
      SettingsService.Timezones(function(success, data) {
        if (callback) {
          callback(success, data);
        }
      });
    };

    service.getSpecialAccountsList = function() {
      BusinessService.SpecialAccounts(function(success, data) {
      });
    };

    service.getSpecialAccountsListCB = function(callback) {
      BusinessService.SpecialAccounts(function(success, data) {
        callback(success, data);
      });
    };

    service.getActualNewsList = function(callback) {
      NewsService.All({count: 20, actual_date: moment().utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')}, function(success, data) {
        callback(success, data);
      });
    };

    service.getGoodsCategoriesList = function(loyalty_id, callback) {
      if (!$rootScope.GOODS_CATEGORIES_FLAT)
        $rootScope.GOODS_CATEGORIES_FLAT = [];

      var params = {
        only_active: false
      };

      GoodsService.Categories(loyalty_id, params, function(success, data) {
        if (success) {
          var r = [],
              l = data,
              depth = 0;

          // noinspection JSAnnotator
          function handleNodes(node, last) {
            var nodes = node.nodes;

            r.push(node);

            if (nodes) {
              for (var i in nodes) {
                nodes[i].depth = node.depth + 1;
                handleNodes(nodes[i], i * 1 === nodes.length - 1);
              }
            } else if (last)
              --depth;
          }

          for (var i in l) {
            l[i].depth = 0;
            handleNodes(l[i]);
          }

          $rootScope.GOODS_CATEGORIES_FLAT[loyalty_id] = angular.copy(r);
        }

        callback(success, $rootScope.GOODS_CATEGORIES_FLAT[loyalty_id]);
      });
    };

    service.makeBusinessSpecialAccountsList = function(callback) {
      BusinessService.SpecialAccountsParams({scope: 'retail'}, function(success, data) {
        callback(data);
      });
    };

    service.makeBusinessCorporateSpecialAccountsList = function(callback) {
      BusinessService.SpecialAccountsParams({scope: 'corporate'}, function(success, data) {
        callback(data);
      });
    };

    return service;
  }

})();
